import { StyleSheet, View, Text } from 'react-native';
import Ionicons from '@expo/vector-icons/Ionicons';
import Button from '../shared/Button';
import { isIosDevice } from '../../services/utils/General';

const PURPLE = '#674FE0';

function Step({ number, icon, children }) {
  return (
    <View style={styles.stepRow}>
      <View style={styles.stepNumber}>
        <Text style={styles.stepNumberText}>{number}</Text>
      </View>
      <View style={styles.stepIcon}>
        <Ionicons name={icon} size={26} color={PURPLE} />
      </View>
      <Text style={styles.stepText}>{children}</Text>
    </View>
  );
}

export default function InstallPrompt({ canInstall, installMessage, onInstall }) {
  const isIos = isIosDevice();

  return (
    <View style={styles.card}>
      <View style={styles.header}>
        <Ionicons name="notifications-outline" size={30} color={PURPLE} />
        <Text style={styles.title}>Get notified when your favorite bar posts</Text>
      </View>
      <Text style={styles.subtitle}>Install BarSwim on your device to choose a favorite bar.</Text>

      {installMessage ? (
        <View style={styles.successRow}>
          <Ionicons name="checkmark-circle" size={24} color="#2e9e5b" />
          <Text style={styles.successText}>{installMessage}</Text>
        </View>
      ) : canInstall ? (
        <Button theme="basic" label="Install BarSwim" onPress={onInstall} />
      ) : isIos ? (
        <View>
          <Step number="1" icon="share-outline">Tap the <Text style={styles.bold}>Share</Text> button at the bottom of Safari</Step>
          <Step number="2" icon="add-circle-outline">Scroll down and tap <Text style={styles.bold}>Add to Home Screen</Text></Step>
          <Step number="3" icon="phone-portrait-outline">Tap <Text style={styles.bold}>Add</Text>, then open <Text style={styles.bold}>BarSwim</Text> from your home screen</Step>
        </View>
      ) : (
        <View>
          <Step number="1" icon="ellipsis-vertical">Open your browser menu</Step>
          <Step number="2" icon="download-outline">Tap <Text style={styles.bold}>Install app</Text> or <Text style={styles.bold}>Add to Home screen</Text></Step>
          <Step number="3" icon="phone-portrait-outline">Open <Text style={styles.bold}>BarSwim</Text> from your home screen or app list</Step>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  card: {
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 14,
    width: '100%',
    borderWidth: 1,
    borderColor: '#e3defa',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  title: {
    flex: 1,
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginLeft: 10,
  },
  subtitle: {
    fontSize: 14,
    color: '#555',
    marginTop: 8,
    marginBottom: 12,
  },
  stepRow: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
  },
  stepNumber: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: PURPLE,
    alignItems: 'center',
    justifyContent: 'center',
  },
  stepNumberText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '700',
  },
  stepIcon: {
    width: 44,
    height: 44,
    borderRadius: 10,
    backgroundColor: '#f1eefd',
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 10,
  },
  stepText: {
    flex: 1,
    fontSize: 14,
    color: '#333',
    lineHeight: 20,
  },
  bold: {
    fontWeight: '700',
  },
  successRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  successText: {
    flex: 1,
    fontSize: 14,
    color: '#333',
    marginLeft: 8,
  },
});
